import Image from 'next/legacy/image';
const Modal = ({
    show,
    onClose,
    label,
    width,
    height,
    hideTitle,
    children,
    labelSize,
    paddingClass = 'p-6',
    ...property
}) => {
    const yScroll = height ? `overflow-y-auto ${height}` : '';
    const lableFontSize = labelSize ? labelSize : 'text-xl md:text-2xl';
    return (
        <>
            <div
                className={`fixed top-0 left-0 flex items-center justify-center w-full h-full modal overflow-y-auto z-50 ${!show && 'hidden'
                    }`}
            >
                <div className="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"></div>

                <div
                    className={`text-basicBlack bg-basicWhite w-full mx-4 md:mx-0 ${width}  rounded-lg shadow-lg z-50 overflow-y-auto`}
                >
                    {!hideTitle && (
                        <div className="flex items-center justify-between p-5 border-b">
                            <p
                                className={`font-semibold text-gray-800  ${lableFontSize}`}
                            >
                                {label}
                            </p>
                            <div className="z-50 cursor-pointer modal-close">
                                <button onClick={onClose}>
                                    <Image
                                        src="/images/close.svg"
                                        width="20"
                                        height="20"
                                    />
                                </button>
                            </div>
                        </div>
                    )}
                    <div className={`${paddingClass} ${property.className} ${yScroll}`}>
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Modal;
